// extracted by mini-css-extract-plugin
export default {"subtitle":"success_subtitle__Fm4CY","bold":"success_bold__qatFy","legal_name":"success_legal_name__W++t6"};